import type { TUserCurrency } from '#shared/types/user.types';

export const EGameEvents = {
  Close: 'game-closed',
} as const;

export const EGameCategory = {
  SoloPlay: 'FP',
  // Legacy_FastPlay: 'FP',
  PlayerVsPlayer: 'PVP',
  FishTableGames: 'FTG',
  ChallengeFriends: 'CAF',
} as const;
export type TGameCategory = (typeof EGameCategory)[keyof typeof EGameCategory];

export interface IBuyInItem {
  maxPrize: string;
  playersMax: number;
  roundTime: number;
  buyInAmount: number;
}

export interface IBulletItem {
  icon: string;
  content: string;
}

export interface IBuyInConfig extends Record<TUserCurrency, IBuyInItem[]> {}

export interface IGameData {
  id: number; // game id
  launchUrl: string; // now we store it in .env files
  title: string; // game title
  techName: string;
  description: string; // single string - can be used in the buy-in popup
  bulletDescription: IBulletItem[]; // 3 bulleted texts on a game card, probably should be stored as a JSON string
  logo: string; // Logo URL - logo is stored separately
  gameType: string; // we use it to find PvP buy-in configs. e.g. 'multi-mines' or 'rolling-21'
  category: TGameCategory; // PVP | FP | FTG | CAF ?
  homeUrlId?: string;
  labels?: string[];
  backButtonURL?: string; // for the in-game back button
  image: string; // Cover URL - regular cover on lobby or pvp page
  imageMostPopular?: string; // URL, we use a different aspect ratio for 'most popular' game covers
  imageCAF?: string; // URL, we use a different aspect ratio for CAF game covers
  comingSoon?: boolean; // we haven't used this field for a while, but it might still be useful in the future
  hidden?: boolean; // can be replaced with 'active'
  paramsType?: 'default' | 'extended'; // default | extended ? can be replaced with isExtended: boolean?
  buyInConfig?: IBuyInConfig; // do we want to store it here or separately?
  buyInBgUrl?: string;
  buyInLogoUrl?: string;
  isNew?: boolean;
  unityGame?: boolean;
  sortOrder?: number;
}

export interface IDeclineUnityChallengePayload {
  gameId: number;
  platformId: string;
  friendId: string;
  roomId: string;
}

export interface IGameHistoryRow {
  gameName: string;
  created: number;
  date: string;
  total_bet: string;
  total_win: string;
  isMultiplayer: boolean;
  currency: TUserCurrency;
  roundId: string;
  totalBet: string;
  totalWin: string;
  gameType: TGameCategory;
}

export interface IPrivateRoomData {
  privateRoomId: string;
  gameId: number;
  bankId: number;
  buyIn: number;
  hostId: string;
  hostDisplayName: string;
  active: boolean;
  dateCreated: number;
}

export interface IIssueChallengeData {
  gameOrigin: string;
  selectedFriends: string[];
  privateRoomDbData: IPrivateRoomData;
  addFriendUrl: string;
  token: string;
}
